import React from 'react'
import { useTheme } from '@ui-kitten/components'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { Text } from '@components/base'
import { ProgressCircle } from '@components'
import { MyPlanCard } from '@screens/Home/components/MyPlan/MyPlanCard.tsx'

interface RecurrenceCallCardProps {
  countOfOccurredRecurrentAppointments: number
  appointmentRecurrenceNumberOfCalls: number
}

export const RecurrenceCallCardProgress = ({
  countOfOccurredRecurrentAppointments,
  appointmentRecurrenceNumberOfCalls,
}: RecurrenceCallCardProps) => {
  const theme = useTheme()
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()

  const handleOnPress = () => {
    navigation.navigate('AllVideoCalls')
  }

  const progressCircle = (
    <>
      <ProgressCircle
        style={styles.progressCircle}
        progress={countOfOccurredRecurrentAppointments / appointmentRecurrenceNumberOfCalls}
        progressColor={theme['theme.info.light_']}
        backgroundColor={theme['theme.surface.base3']}
        strokeWidth={6}
      />
      <Text type="large" bold style={styles.progressText}>
        {appointmentRecurrenceNumberOfCalls - countOfOccurredRecurrentAppointments}
      </Text>
    </>
  )

  return (
    <MyPlanCard
      leftAccessory={progressCircle}
      primaryText="Complete initial calls!"
      secondaryText="Complete your remaining initial calls to achieve your weight loss goal!"
      handleOnPress={handleOnPress}
    />
  )
}

const themedStyle = StyleService.create({
  progressCircle: {
    width: '100%',
    height: '100%',
  },
  progressText: {
    position: 'absolute',
    color: 'theme.text.primary',
  },
})
